import { render } from "./HospitalDoctorProfileTabs.vue?vue&type=template&id=40e4ae4c&ts=true"
import script from "./HospitalDoctorProfileTabs.vue?vue&type=script&lang=ts"
export * from "./HospitalDoctorProfileTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__